export const admissions = {
  title: "Processus d'Admission",
  subtitle: "Nous vous accompagnons à chaque étape pour rejoindre notre communauté éducative",
  process: {
    title: "Étapes pour rejoindre Gándara",
    steps: [
      {
        title: "Contact initial",
        description: "Contactez-nous par téléphone, email ou via notre site web pour exprimer votre intérêt."
      },
      {
        title: "Visite guidée",
        description: "Réservez une visite pour découvrir nos installations, méthodologie et équipe éducative. Vous pourrez résoudre tous vos doutes."
      },
      {
        title: "Demande d'admission",
        description: "Complétez le formulaire d'inscription avec les informations de votre enfant et de votre famille."
      },
      {
        title: "Entretien familial",
        description: "Nous aurons une conversation avec la famille pour mieux vous connaître et nous assurer que nous partageons les mêmes valeurs et attentes."
      },
      {
        title: "Confirmation et inscription",
        description: "Si des places sont disponibles et que les deux parties sont d'accord, nous procéderons à la formalisation de l'inscription."
      }
    ]
  },
  requirements: {
    title: "Documentation nécessaire",
    items: [
      "Formulaire d'inscription complet",
      "Copie de la carte d'identité/passeport de l'élève",
      "Copie de la carte d'identité des parents/tuteurs",
      "Certificat de naissance",
      "Certificat médical à jour",
      "Photo d'identité récente",
      "Justificatif de paiement des frais d'inscription"
    ]
  },
  visit: {
    title: "Réservez votre visite",
    description: "La première étape est de nous connaître. Programmez une visite pour découvrir Gándara.",
    button: "Programmer une visite"
  },
  contact: {
    title: "Vous avez des questions?",
    description: "Nous sommes là pour vous aider. Contactez-nous et nous répondrons à toutes vos questions.",
    button: "Nous contacter"
  }
};
